__turbopack_context__.v({
  "active": "I8KhCW_active",
  "checkmark": "I8KhCW_checkmark",
  "content": "I8KhCW_content",
  "label": "I8KhCW_label",
  "monthlyValueColor": "I8KhCW_monthlyValueColor",
  "option": "I8KhCW_option",
  "perYear": "I8KhCW_perYear",
  "tallOption": "I8KhCW_tallOption",
  "value": "I8KhCW_value",
  "wrapper": "I8KhCW_wrapper",
});
